import React from 'react';
import PagosPendientesTable from './TablePagosPendientes/TablePagosPendientes';

const PagosPendientes = () => {
  return <PagosPendientesTable/> ;
};

export default PagosPendientes;
